import { safetyMargins, HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { makeDefaultStylingContext } from '../../tornado/utils/style';
import { SCREEN_WIDTH, SCREEN_HEIGHT } from '../../tornado/utils/sizes';
import { ICON_HEIGHT } from './playbackStateIndicator/playbackStateIndicator.style';
import { DISPLAY_AD_METADATA, DISPLAY_SHADOW_OVERLAY } from './ads.constants';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  text: makeThemeColor(PRIMARY),
};

export const METADATA_MARGIN_BOTTOM = {
  [HD]: 8,
  [FULL_HD]: 16,
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize } = context;

  const margin = {
    x: safetyMargins.horizontal[screenSize],
    y: safetyMargins.vertical[screenSize],
  };

  const playbackStateIndicatorY = SCREEN_HEIGHT[screenSize] - margin.y;

  return {
    w: SCREEN_WIDTH[screenSize],
    h: SCREEN_HEIGHT[screenSize],
    Overlay: {
      visible: DISPLAY_SHADOW_OVERLAY,
    },
    TopBar: {
      visible: DISPLAY_AD_METADATA,
      ...margin,
    },
    Metadata: {
      visible: DISPLAY_AD_METADATA,
      x: margin.x,
      y: playbackStateIndicatorY - ICON_HEIGHT[screenSize] - METADATA_MARGIN_BOTTOM[screenSize],
      mountY: 1,
    },
    PlaybackStateIndicator: {
      visible: DISPLAY_AD_METADATA,
      x: margin.x,
      y: playbackStateIndicatorY,
      mountY: 1,
    },
    Countdown: {
      mountX: 1,
      x: v => v - safetyMargins.horizontal[screenSize],
      y: safetyMargins.vertical[screenSize],
      displayIcon: false,
    },
    Skip: {
      visible: false,
      mount: 1,
      x: v => v - safetyMargins.horizontal[screenSize],
      y: v => v - safetyMargins.vertical[screenSize],
    },
    AdJingle: {
      w: SCREEN_WIDTH[screenSize],
      h: SCREEN_HEIGHT[screenSize],
    },
  };
};
